<template>
  <div
    id="preloader"
    class="col-md-10 col-md-offset-1"
  >
    <br>

    <h2>{{ $localize('PageNotAvailableTitle') }}</h2>
    <p>{{ $localize('PageNotAvailableText') }}</p>

    <p>
      <a href="#requests">{{ $localize('ReturnToRequestList') }}</a>
    </p>
  </div>
</template>
